import { makeStyles } from '@material-ui/core/styles';
import { PrimaryColors, SurfaceColors, TextColors } from '@/utils/constants';

const lightTheme = {
  root: {
    backgroundColor: SurfaceColors.light,
    color: TextColors.dark,
  },
};

const darkTheme = {
  root: {
    backgroundColor: PrimaryColors.light,
    color: TextColors.light,
  },
};

const useStyles = makeStyles(
  () => ({
    root: {
      height: '100%',
      padding: '50px 24px',
      textAlign: 'center',
      '&.light-theme': lightTheme.root,
      '&.dark-theme': darkTheme.root,
    },
    img: {
      marginBottom: '22px',
    },
    description: {
      '&.MuiTypography-root': {
        marginBottom: '22px',
      },
    },
  }),
  { name: 'GenSquareCTATile' },
);

export default useStyles;
